import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { allTrainingListDetails } from "../../../redux/actions/payment/training_action";
import AlertMessage from "../../../common/actions/AlertMessage";
import Loader from "../../../common/loaders/Loader";
import PageTitle from "../../../common/shared/PageTitle";
import MoneyIcon from "../../../common/icons/moneyIcon";
import DownloadButton from "../../../common/buttons/DownloadButton";
import saveDownload from "../../../utils/downloadFile";
import { Card, CardBody } from "@material-tailwind/react";
import { DataGrid } from "@mui/x-data-grid";

function SingleTraining() {
  const { id } = useParams();

  const [loading, setLoading] = useState(true);

  const dispatch = useDispatch();

  const { data, message } = useSelector((state) => state.training);

  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    { field: "name", headerName: "Name", flex: 1 },
    { field: "bar_number", headerName: "Bar Number", width: 100 },
    // { field: "amount", headerName: "Amount", width: 100 },
    // { field: "date_paid", headerName: "Date Paid", width: 150 },
    // { field: "type", headerName: "Type", width: 150 },
    { field: "chamber", headerName: "Chamber", flex: 1 },
    {
      field: "status",
      headerName: "Status",
      width: 100,
      renderCell: (params) => {
        const statusValue = params.row.status;

        return (
          <span
            className={`inline-flex items-center rounded-md ${
              statusValue === "Paid"
                ? "bg-green-50 text-green-700 ring-green-600/20"
                : statusValue === "Pending"
                ? "bg-orange-50 text-orange-700 ring-orange-600/20"
                : "bg-blue-50 text-blue-700 ring-blue-600/20"
            } px-2 py-1 text-xs font-medium ring-1 ring-inset`}
          >
            {statusValue}
          </span>
        );
      },
    },
  ];

  useEffect(() => {
    dispatch(allTrainingListDetails(id)).finally(() => setLoading(false));
  }, [dispatch, id]);

  return (
    <>
      {message && <AlertMessage type="error" message={message} />}

      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="flex justify-between p-4">
            <div className="flex items-center">
              <PageTitle
                title="Payment List"
                // title={data.product}
                subheading={data.details.length}
                icon={<MoneyIcon />}
              />
            </div>

            <div className="flex items-center gap-4">
              <DownloadButton
                onClick={() => saveDownload(data.details, "Meeting & Training")}
              />
            </div>
          </div>

          {/* <PaymentTable data={data.details} columns={columns} /> */}

          <Card className="w-full p-6 shadow-xl mb-20">
            <CardBody>
              <DataGrid
                sx={{ border: 0 }}
                initialState={{
                  columns: {
                    columnVisibilityModel: {
                      date_paid: false,
                    },
                  },
                }}
                rows={data.details
                  .filter((row) => row.status === 1 || row.status === 0)
                  .map((row, index) => ({
                    ...row,
                    arrayIndex: index,
                    status:
                      row.status === 1
                        ? "Paid"
                        : row.status === 0
                        ? "Pending"
                        : null,
                  }))}
                columns={columns}
              />
            </CardBody>
          </Card>
        </>
      )}
    </>
  );
}

export default SingleTraining;
